import type { NavigateFunction } from 'react-router-dom';
import { pushRecentlyViewed, type SearchResultData, type RecentlyViewedEntry } from './searchTypes.ts';

// ─── Single shared navigation function ─────────────────────────────────────────
// Used by Enter, row click, and the preview pane's "Open"/"Open item"/etc. button -- this is the
// ONE place that decides where a result goes, replacing the old per-click switch that used to
// live in TopBar.tsx's handleResultClick.
//
// Every type's `route` field is computed server-side and already matches the exact path the old
// TopBar switch used (see CLAUDE_RULES.md's "Global search → ..." locked behaviors). The one
// exception is 'catalogue': that flow has always used react-router *state* (not a query string)
// to tell Inventory.tsx which item to auto-open -- `route` is left blank for that type server-side
// specifically because it can't be expressed as a plain path, so it's special-cased here instead.
export function navigateToResult(navigate: NavigateFunction, r: SearchResultData | RecentlyViewedEntry) {
  if (r.type === 'catalogue') {
    // `_t` is a unique-per-click nonce, not consumed for anything except making the state object
    // itself unique. Without it, clicking the SAME catalogue result twice in a row (e.g. after
    // closing its edit panel) would push a react-router state identical in VALUE to the one
    // Inventory.tsx already latched onto via its id-keyed ref guard, so the second click would be
    // silently ignored even though a fresh open was clearly intended.
    navigate('/inventory', { state: { openItemId: r.id, tab: 'catalogue', _t: Date.now() } });
  } else {
    navigate(r.route || '/dashboard');
  }
  if ('previewFields' in r) pushRecentlyViewed(r);
}
